import { getVaultAncestors } from '@/api';
import { vaultDirectoryRoute } from '@/router/links';
import { useVaultStore } from '@/stores/vaultStore';
import { logger } from '@/utils/logger';
import type { RouteLocationRaw } from 'vue-router';

/**
 * Where to land once a contract is gone (deleted, converted, or deleted with
 * its last file): the vault folder it sat in. Resolve it before the change —
 * afterwards the contract has no trail. Falls back to the vault root when the
 * folder is unreadable or the lookup fails.
 */
export async function contractFolderRoute(
  kind: 'contract' | 'contract_file',
  uid: string
): Promise<RouteLocationRaw> {
  try {
    const [response, rootUid] = await Promise.all([
      getVaultAncestors({ query: { kind, uid } }),
      useVaultStore().resolveRootDirectoryUid(),
    ]);
    const folder = (response.data ?? []).filter(ancestor => ancestor.kind === 'directory').at(-1);
    if (folder && folder.uid !== rootUid) return vaultDirectoryRoute(folder.uid);
  } catch (error) {
    logger.error('Failed to resolve the contract folder:', error);
  }
  return { name: 'file-vault' };
}
